import { Injectable } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from  '@angular/common/http';
import {Documento} from '../clase/documento';
import { timeout } from 'rxjs/operators';
import { catchError, tap } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { environment } from '../../environments/environment';

@Injectable()
export class Servicio {
    constructor(private http: HttpClient,public cargar:NgxUiLoaderService) {}
//public url_global="https://extranet.coopacsanmartin.pe/webservice_seguro/";
//public url_global = "http://localhost:8080/sol/";
//public url_global = "https://testing.coopacsanmartin.pe/sol/";
 public url_global = environment.apiUrl;

publicurl_simple="http://extranet.coopacsanmartin.pe/webservice_seguro/";
   enviar_servidor(url,json={})
   {
    let headers=new Headers(
        {
          "Content-type":"application/json",
          'authorization': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZF9kaXNwb3NpdHZvIjoiOWZhZTQ3MGJkNDljODUxNSJ9.ZAnApn6H7-K7Op9ajyo99icrxJX3TcR6aforan3y3KY'
        }
      );

       return  this.http.post("Login/iniciar_sesion_usuario",json).subscribe(data => {

        });

   }

   enviar(url,json={})
   {

    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type':  'application/json',

      })
    };
    return  this.http.post(this.url_global+url,json,httpOptions).pipe(map(
        res=>{

          return res;
        }
      ));
   }

   enviar_seguro(url,json={},token)
   {
      let _this=this;
    const httpOptions = {
      headers: new HttpHeaders({

        'Accept': 'application/json',
        'Content-Type':  'application/json',
        'authorization': token



      })
    };
    return  this.http.post(this.url_global+url,json,httpOptions).pipe(map(
        res=>{
       // console.log(res);
      //  alert();
          return res;
        },error=>{

          console.log(error);
        }
      ),catchError((err) => {
        _this.cargar.stop();
        Swal.fire(
          'ERROR!',
          "Su sesión a caducado , por favor inicie sesión nuevamente",
          'error'
        ).then((result) => {
          if (result.isConfirmed) {

            sessionStorage.removeItem('currentUser');
            location.reload();
          }
        });
        throw 'Error in source. Details: ' + err; // Use console.log(err) for detail
    }));

   }

   enviar_constancia(token,correo,nombre,titulo,datos={},cuenta)
   {

    let json={};
    json["cuenta"]=cuenta;
    json["correo"]=correo;
    json["nombre"]=nombre;
    json["titulo"]=titulo;
    json["datos"]=datos;




    const httpOptions = {
      headers: new HttpHeaders({

        'Accept': 'application/json',
        'Content-Type':  'application/json',
        'authorization': token



      })
    };
    return  this.http.post(this.url_global+"api/ws_enviar_correo_constancia",json,httpOptions).pipe(map(
        res=>{

          //alert(res);

          return res;
        }
      ));

   }



   formatMoney(number, decPlaces, decSep, thouSep) {
    decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
    decSep = typeof decSep === "undefined" ? "." : decSep;
    thouSep = typeof thouSep === "undefined" ? "," : thouSep;
    var sign = number < 0 ? "-" : "";
    let i:any;
     i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
    var j = (j = i.length) > 3 ? j % 3 : 0;

    return sign +
      (j ? i.substr(0, j) + thouSep : "") +
      i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
      (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
    }
}
